<script>
import { mapGetters, mapActions } from "vuex";
import InfoChart from "../base/InfoChart.vue";
import { BaseIcon } from "@/components";
import mixins from "../../mixins";

export default {
  name: "FundCommissionRate",
  props: {
    customerId: Number,
  },
  components: {
    InfoChart,
    BaseIcon,
  },
  mixins: [mixins],
  data() {
    return {
      pricesList: [],
      stateListChecker: false,
    };
  },
  mounted() {
    const cusId = this.customerId;
    this.getFundCommissionRate({
      customerId: parseInt(this.getUserInfo?.id),
      id: cusId,
      period: 1,
      cusId: cusId !== undefined ? cusId : null,
    }).then(() => {
      this.pricesList = this.hasPriceArray;
    });
    this.clearPackages();
  },

  methods: {
    ...mapActions(["getFundCommissionRate", "clearPackages"]),
  },

  computed: {
    ...mapGetters([
      "fundAndCommissionRates",
      "customer",
      "getUserInfo",
      "allPackages",
    ]),

    hasData() {
      return this.fundAndCommissionRates.period;
    },
    hasPriceArray() {
      return this.fundAndCommissionRates?.price?.prices;
    },
    isCompleted() {
      return (
        (this.fundAndCommissionRates.fundAmount !== 0 &&
          parseInt(this.fundAndCommissionRates.fundAmount) >=
            this.fundAndCommissionRates.price.totalFundAmount) ||
        (this.fundAndCommissionRates.commissionAmount !== 0 &&
          parseInt(this.fundAndCommissionRates.commissionAmount) >=
            this.fundAndCommissionRates.price.totalCommissionAmount)
      );
    },
  },
  watch: {
    getFundCommissionRate() {
      this.pricesList = this.hasPriceArray;
    },
    allPackages(state) {
      this.stateListChecker = state.data.length > 0;
    },
  },
};
</script>

<template>
  <div class="fund-commission comission-container custom-container">
    <div class="comission-container-title">
      <h6>
        Komisyon veya BES/Fon Büyüklüğü Durumunuz
        <span class="period" v-if="hasData"
          >({{ fundAndCommissionRates.period }})
        </span>
        <span class="comission-container-bes-cr-warning">
          <div class="tag tooltip">
            <div class="tooltiptext">
              <div class="texts">
                Uyarı: Burada görülen komisyon büyüklüğü, brüt hesaplama sonucu
                olup, komisyon iadelerini içermemekte ve indikatif olarak
                gösterim yapılmaktadır. Ücretsiz kullanım için gerekli komisyon
                tutarı, ay içerisinde ve takip eden ayın ilk günü gerçekleşen
                komisyon iadeleri düşülerek hesaplanmakta olup ay sonu
                raporlarında gösterilmektedir.
              </div>
              <div class="triangle-down"></div>
            </div>
            <span class="text">
              <base-icon name="green-info" class="icon"></base-icon
            ></span>
          </div>
        </span>
      </h6>
    </div>
    <div class="comission-container-charts" v-if="hasData">
      <info-chart
        name="BES/FON BÜYÜKLÜĞÜ"
        :withOtherPrices="false"
        :amount="fundAndCommissionRates.fundAmount"
        :total="fundAndCommissionRates.price.totalFundAmount"
      ></info-chart>
      <info-chart
        name="KOMİSYON"
        :withOtherPrices="false"
        :amount="fundAndCommissionRates.commissionAmount"
        :total="fundAndCommissionRates.price.totalCommissionAmount"
      ></info-chart>
      <info-chart
        :name="
          hasData.toLocaleUpperCase('tr-TR') +
          ' AYI KULLANDIĞINIZ PAKETLERİN TUTARI'
        "
        :amount="fundAndCommissionRates.commissionAmount"
        :withOtherPrices="true"
        :total="fundAndCommissionRates.targetCommissionAmount"
        :pricesList="pricesList"
      ></info-chart>
    </div>

    <div
      class="comission-container-details"
      v-if="hasData && isCompleted && stateListChecker"
    >
      <div class="comission-container-info">
        <base-icon
          name="check-circle-fill"
          className="comission-container-info__check"
        ></base-icon>
        <p>Ücretsiz veri kullanımı için minimum tutara ulaştınız.</p>
        <br />
      </div>
    </div>

    <div
      class="comission-container-default danger"
      v-if="hasData && !isCompleted && stateListChecker"
    >
      <base-icon
        name="red-info"
        className="comission-container-info__check"
      ></base-icon>
      <p>Ücretsiz veri kullanımı için gerekli tutara ulaşamadınız.</p>
    </div>
    <div class="comission-container-details">
      <div class="comission-container-info-row">
        <h3>Ücretsiz Kullanımdan Nasıl Yararlanabilirim?</h3>
        <p>
          Ücretsiz kullanım koşullarından yararlanabilmeniz için ayın son işlem
          gününden bir gün önceki iş gününün piyasa kapanış verileri dikkate
          alınarak hesaplanmış portföy büyüklüğünüzün veya ay sonu iade sonrası
          komisyon miktarınızın, kullandığınız paketlerin gerekli komisyon
          tutarı veya portföy büyüklüğü şartını sağlaması gerekmektedir.
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.comission-container {
  background: #fff;
  &.fund-commission {
    @media (max-width: 1400px) {
      margin-bottom: 0;
    }
    @media (max-width: 475px) {
      .container-title {
        margin-bottom: 20px;
      }
    }
  }

  &-title {
    padding: 20px 0px;
    @media (max-width: 768px) {
      padding: 16px 0px;
    }
    h6 {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      color: var(--color-primary-black-metallic);
      .tooltiptext {
        line-height: normal;
      }
      @media (max-width: 768px) {
        text-align: center;
        font-size: 14px;
        line-height: 19px;
      }
    }

    .period {
      color: var(--grayscale-60);
      font-weight: normal;
    }
  }

  &-charts {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
    text-align: center;
    margin-bottom: 20px;

    @media screen and (max-width: 1145px) {
      justify-content: center;
    }
    @media (max-width: 768px) {
      gap: 16px;
    }
  }

  &-info-row {
    color: var(--color-primary-black-metallic);
    padding-top: 20px;
    display: flex;
    flex-direction: column;

    h3 {
      font-size: 16px;
      margin-bottom: 13px;
      @media (max-width: 768px) {
        font-size: 13px;
        font-weight: 500;
      }
    }
    p {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 20px;
      line-height: 24px;
      color: var(--color-primary-gray-metallic);
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    svg {
      width: 55px;
      @media (max-width: 992px) {
        width: 105px;
      }
      @media (max-width: 475px) {
        width: 205px;
      }
      filter: invert(45%) sepia(12%) saturate(1419%) hue-rotate(125deg)
        brightness(95%) contrast(87%);
    }
  }
  &-info {
    display: flex;
    align-items: center;
    color: var(--color-primary-default);
    @media (max-width: 768px) {
      align-items: flex-start;
    }
    p {
      font-size: 13px;
    }

    &__check {
      margin-right: 5px;

      @media (max-width: 768px) {
        width: 55px;
      }
    }
    @media (max-width: 475px) {
      margin-top: 20px;
    }
  }

  &-default {
    color: #e53935;
    &.danger {
      background: rgba(229, 57, 53, 0.1);
      padding: 12px 20px;
      display: flex;
      align-items: center;
      @media (max-width: 768px) {
        padding: 12px;
        align-items: flex-start;
      }
      @media (max-width: 575px) {
        svg {
          margin: 0 auto;
        }
      }
      p {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        @media (max-width: 768px) {
          justify-content: flex-start;
          text-align: left;
          font-size: 13px;
        }
      }
    }
  }
}

.comission-container-bes-cr-warning {
  position: relative;
  top: 6px;
  .tag {
    margin-right: 10px;
    border-radius: var(--radius-third);
    align-items: center;
    text-align: center;
    max-width: 110px;
    display: inline-flex !important;

    .tooltiptext {
      @media (max-width: 768px) {
        left: 290px;
        transform: translateX(-500px);
        line-height: normal;
        min-width: 245px;
        top: 100%;
        z-index: 1;
        height: max-content;
        bottom: auto;
      }

      .texts {
        font-size: 12px;
        font-weight: normal;
      }
      .triangle-down {
        @media (max-width: 768px) {
          border-top: none;
          border-bottom: 8px solid #7ea7a3;
          bottom: auto;
          top: -8px;
          &::after {
            border-bottom: 6px solid #f2f7f6;
            border-top: none;
            bottom: auto;
            top: 1px;
          }
        }
      }
    }

    .text {
      font-size: 12px;
      text-overflow: ellipsis;
      display: flex;
      align-items: center;
    }
  }
}
</style>
